module.exports = __webpack_public_path__ + "f3380a215fe2c21fd2ebbae416b1a6a2.png";